import Rails from '@rails/ujs';
import 'bootstrap';
// import * as ActiveStorage from '@rails/activestorage';
import 'channels';
import Turbolinks from 'turbolinks';
import '../angularjs';
import '../reactjs';
import '../scripts';
import Swal from 'sweetalert2/dist/sweetalert2.js'
window.Swal = Swal;

Rails.start();
Turbolinks.start();
ReactRailsUJS.detectEvents();

// ActiveStorage.start();
// Support component names relative to this directory:
